import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import i18n from './plugins/i18n';
import './scss/app.scss';
import vClickOutside from 'click-outside-vue3';
import mitt from 'mitt';
import Maska from 'maska';
import useLaravelEcho from './app/shared/modules/use-laravel-echo';
import useSentry from './app/shared/modules/use-sentry';
import useVitePwa from './app/shared/modules/use-vite-pwa';
import VueTippy from 'vue-tippy';

const { init: initPWA } = useVitePwa();
const { init: initSentry } = useSentry();
const { echo } = useLaravelEcho();
const emitter = mitt();
const app = createApp(App)
  .use(router)
  .use(Maska)
  .use(createPinia())
  .use(i18n)
  .use(VueTippy, {
    defaultProps: {
      theme: 'light',
    },
  })
  .use(vClickOutside);

initSentry(app);
initPWA();

app.provide('emitter', emitter);
app.provide('echo', echo);
app.mount('#app');
